enum PickupAndDeliveryOption {
  Delivery = 'delivery',
  Pickup = 'pickup',
  PickupAndDelivery = 'pickupAndDelivery'
}

export default PickupAndDeliveryOption;
